function removeNonCity(suggestions) {
	return suggestions.filter(function(suggestion) {
		return suggestion.data.fias_level !== "65";
	});
}

export class Order {
	mobileAndTabletCheck()
	{
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}
	addToCart(id) {
		$.ajax({
			url: "/ajax.php?mid=21",
			type: 'POST',
			data: {
				action: 'add',
				id: id
			},
			dataType: "json",
			success: function (res) {
				if (res['success']) {
					var count = res['new_count'];
					var end;

					$('.user-cart__quantity').text(count);
					if (res['new_count']) {
						$('.user-cart').addClass('active');
					}

					//$('.popup-addition').removeClass('active');
					//$('.popup-cart').addClass('active');
				}
				else {
					alert(res['error']);
				}
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
			}
		});
	}

	updateCartCount(item, parent) {
		let _this = this;

		$('.ordering-delivery').addClass('loading');
		$('.ordering-delivery__loader, .ordering-summary__loader').addClass('active');
		let count = $(parent).val();
		$.ajax({
			url: "/ajax.php?mid=25",
			type: 'POST',
			data: {
				action: 'updateCartCount',
				id: item,
				count: count,
				type: 'sdek',
				code: cookie.get('sdek_id'),
				delivery_type: $('.ordering-delivery__choose-input:checked').val(),
				address: this.address,
				pvz: this.pvz,
				promo: this.promo
			},
			dataType: "json",
			success: function (res) {
				if (res['success']) {
					let elPrice = $(parent).closest('.cart-item').find('.cart-item__price-main');
					let elOldPrice = $(parent).closest('.cart-item').find('.cart-item__price-old');
					elPrice.text(elPrice.data('price') * count + '\xa0₽');
					elOldPrice.text(elOldPrice.data('price') * count + '\xa0₽');
					_this.recalcSum(res);
					$('.ordering-delivery').removeClass('loading');
					$('.ordering-delivery__loader, .ordering-summary__loader').removeClass('active');

					/*if (count == 0)
						location.reload();*/
				}
				else {
					alert(res['error']);
				}
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
			}
		});
	}

	deleteRestoreCart(item, parent, op) {
		let _this = this;

		$('.ordering-delivery').addClass('loading');
		$('.ordering-delivery__loader, .ordering-summary__loader').addClass('active');
		$.ajax({
			url: "/ajax.php?mid=25",
			type: 'POST',
			data: {
				action: 'deleteRestoreCart',
				op: op,
				id: item,
				type: 'sdek',
				code: cookie.get('sdek_id'),
				delivery_type: $('.ordering-delivery__choose-input:checked').val(),
				address: this.address,
				pvz: this.pvz,
				promo: this.promo
			},
			dataType: "json",
			success: function (res) {
				if (res['success']) {
					if (op == 'delete')
						$(parent).closest('.ordering-cart__item.cart-item').find('.cart-item__deleted').addClass('active');
					else
						$(parent).closest('.ordering-cart__item.cart-item').find('.cart-item__deleted').removeClass('active');

					_this.recalcSum(res);
					$('.ordering-delivery').removeClass('loading');
					$('.ordering-delivery__loader, .ordering-summary__loader').removeClass('active');

					/*if (count == 0)
						location.reload();*/
				}
				else {
					alert(res['error']);
				}
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
			}
		});
	}

	getCosting(recalcDelivery = false) {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=25",
			type: 'POST',
			data: {
				action: 'getCosting',
				type: 'sdek',
				code: cookie.get('sdek_id'),
				delivery_type: $('.ordering-delivery__choose-input:checked').val(),
				recalc_delivery: recalcDelivery,
				address: this.address,
				pvz: this.pvz,
				promo: this.promo
			},
			dataType: "json",
			success: function (res) {
				_this.recalcSum(res);
				$('.form__loader').removeClass('active');
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
				$('.form__loader').removeClass('active');
			}
		});
	}

	addPromo(parent) {
		let recalcDelivery = false;
		let b = $(parent).closest('.form__item');
		let promo = b.find('input[name=promo_code]').val()
		if (promo != this.promo)
		{
			this.promo = promo;
			$('.ordering-promo__loader').addClass('active');
			recalcDelivery = true;
		}
		this.getCosting(recalcDelivery);
	}

	recalcSum(res) {
		let _this = this;

		console.log(res);
		$('.user-cart__quantity').text(res.count);
		if (res.count) {
			$('.user-cart').addClass('active');
		}
		else
		{
			$('.user-cart').removeClass('active');
		}
		$('.ordering-cart__title sup').text(res.count);

		$('.summary-count').text(res.count);
		$('.summary-sum').text(res.old_sum + '\xa0₽');
		$('.summary-discount').text(res.discount + '\xa0₽');
		$('.summary-total').text(res.sum + '\xa0₽');
		$('.order-total-sum').text(res.sum + '\xa0₽');
		$('.order-total-sum').data('sum', res.sum);

		if (res.discount > 0)
		{
			$('.summary-sum').closest('.ordering-summary__figures-item').fadeIn();
			$('.summary-discount').closest('.ordering-summary__figures-item').fadeIn();
			$('.summary-total').closest('.ordering-summary__figures-item').hide();
		}
		else
		{
			$('.summary-sum').closest('.ordering-summary__figures-item').hide();
			$('.summary-discount').closest('.ordering-summary__figures-item').hide();
			$('.summary-total').closest('.ordering-summary__figures-item').fadeIn();
		}

		if (res.pickup)
		{
			$('.ordering-delivery__choose-label[for="delivery_type_1"] .ordering-delivery__choose-info').text(
				'от\xa0' + res.pickup.delivery_sum + '\xa0₽ | от\xa0' + res.pickup.calendar_min + '\xa0дн' + _this.ending(res.pickup.calendar_min, 'я', 'ей', 'ей'));
		}
		if (res.courier)
		{
			$('.ordering-delivery__choose-label[for="delivery_type_2"] .ordering-delivery__choose-info').text(
				'от\xa0' + res.courier.delivery_sum + '\xa0₽ | от\xa0' + res.courier.calendar_min + '\xa0дн' + _this.ending(res.courier.calendar_min, 'я', 'ей', 'ей'));
		}

		if (typeof res.delivery_sum == 'number')
		{
			$('.order-delivery-price').text(res.delivery_sum + ' ₽');
			//$('.order-delivery-term').text(res.calendar_min + '-' + res.calendar_max + ' дня');

			$('#delivery_price').val(res.delivery_sum);
			$('.order-total-sum').text((parseInt($('.order-total-sum').data('sum')) + parseInt(res.delivery_sum)) + '\xa0₽');
		}

		if (res.promo_applied)
		{
			$('.ordering-promo__activated').text('Промокод ' + res.promo_applied + ' применён!');
			$('.ordering-promo__activated').show();
			$('.ordering-promo .form__item-mistake').text('');
			$('.ordering-promo .form__item-mistake').hide();
		}
		else if (this.promo)
		{
			$('.ordering-promo__activated').text('');
			$('.ordering-promo__activated').hide();
			$('.ordering-promo .form__item-mistake').text('Промокод недействителен');
			$('.ordering-promo .form__item-mistake').show();
		}
		else
		{
			$('.ordering-promo__activated').text('');
			$('.ordering-promo__activated').hide();
			$('.ordering-promo .form__item-mistake').text('');
			$('.ordering-promo .form__item-mistake').hide();
		}
	}

	makeOrder(parent) {
		$('.ordering__loader').addClass('active');
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=21",
			type: 'POST',
			data: $(parent).serialize() + '&pvz_code=' + this.pvz + '&action=makeOrder',
			dataType: "json",
			success: function (res)
			{
				if (res['success'])
				{
					_this.orderId = res['orderId'];
					if (res['payURL'])
					{
						window.location.replace(res['payURL']);
					}
					else
					{
						_this.showSBPay(_this.orderId, res['QR']['payload'], res['QR']['renderedQr'], res['sum']);
					}
				}
				else if (res['fatal'])
				{
					alert(res['error']);
					$('.ordering__loader').removeClass('active');
				}
				else
				{
					console.log(res['error']);
					$('.ordering__loader').removeClass('active');
					window.location.replace('/lk/orders/' + (cookie.get('orderId') ? cookie.get('orderId') + '/' : ''));
				}

			},
			error: function (err) {
				console.log('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
				$('.ordering__loader').removeClass('active');
				window.location.replace('/lk/orders/' + (cookie.get('orderId') ? cookie.get('orderId') + '/' : ''));
			}
		});
	}

	fastOrder(parent) {
		$('.ordering__loader').addClass('active');
		this.fast = true;
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=21",
			type: 'POST',
			data: $(parent).serialize() + '&action=fastOrder',
			dataType: "json",
			success: function (res)
			{
				if (res['success'])
				{
					_this.orderId = res['orderId'];
					if (res['payURL'])
					{
						window.location.replace(res['payURL']);
					}
					else
					{
						_this.showSBPay(_this.orderId, res['QR']['payload'], res['QR']['renderedQr'], res['sum']);
						$('.ordering__loader').removeClass('active');
						_this.payId = res['payId'];
					}
				}
				else
				{
					alert(res['error']);
					$('.ordering__loader').removeClass('active');
				}

			},
			error: function (err) {
				console.log('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
				$('.ordering__loader').removeClass('active');
				window.location.replace('/lk/orders/' + (cookie.get('orderId') ? cookie.get('orderId') + '/' : ''));
			}
		});
	}

	checkEmail(parent)
	{
		$('.ordering-summary__submit-btn').prop('disabled', !$(parent).is(':valid'));
	}

	showSBPay(orderId, payload, renderedQr, sum)
	{
		let _this = this;

		if (this.mobileAndTabletCheck())
		{
			const slideUpWidget = new SlideUpWidget(
								window.localStorage,
								window.navigator
			);
			slideUpWidget.showBankSelector(payload);
			if (location.pathname == '/ordering/')
			{
				setTimeout(function(){$('.slide-up-widget__header-close-btn').click(function(){
					window.location.replace('/lk/orders/' + orderId + '/');
				})}, 400);
			}
		}
		else
		{
			$('.popup-qr-payment .text-block img').attr('src', 'data:image/png;base64, ' + renderedQr);
			$('.popup-qr-payment .text-block .qr-payment-sum').text(sum + '\xa0₽');
			$('.popup-qr-payment').addClass('active');
			$('body').addClass('no-scroll');
		}

		this.payAttempt = 0;
		this.orderId = orderId;
		setInterval(function(){
			_this.checkPay();
		}, 3000);
	}

	loadSBPay(orderId, parent)
	{
		let _this = this;
		$(parent).prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=15",
			type: 'POST',
			data: {
				action: 'requestQR',
				id: orderId
			},
			dataType: "json",
			success: function (res)
			{
				if (res['success'])
				{
					_this.showSBPay(orderId, res['QR']['payload'], res['QR']['renderedQr'], res['sum']);
				}
				else
				{
					alert(res['error']);
				}

				$(parent).prop('disabled', false);
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
				$(parent).prop('disabled', false);
			}
		});
	}

	checkPay() {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=21",
			type: 'POST',
			data: {
				action: 'checkPay',
				id: this.orderId
			},
			dataType: "json",
			success: function (res) {
				if (res['success']) 
				{
					if (_this.fast)
					{
						window.location.replace('/pay/success/' + _this.orderId + '/?orderId=' + _this.payId);
					}
					else
					{
						window.location.replace('/lk/orders/' + _this.orderId + '/');
					}
				}
				else if (res['fail']) 
				{
					if (_this.fast)
					{
						window.location.replace('/pay/fail/' + _this.orderId + '/?orderId=' + _this.payId);
					}
					else
					{
						window.location.replace('/lk/orders/' + _this.orderId + '/');
					}
				}
				/*else if (_this.payAttempt >= 4) {

				}*/
				else {
					_this.payAttempt++;
				}

			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err);
			}
		});
	}

	validAdress(adress) {
		$("input[type=submit]").prop("disabled", true)
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=60&action=validAdress",
			type: "POST",
			data: { adress: adress },
			dataType: "json",
			success: function (res) {
				$("input[type=submit]").prop("disabled", false)
				let field = $("#str_adress")
				let qc_text = {
					10: "неизвестный дом",
					9: "неизвестный адрес",
					7: "похоже на иностранный адрес",
					6: "неизвестный нам адрес :-(",
					5: "еще можно указать квартиру",
					4: "укажите дом",
					3: "укажите улицу",
					2: "укажите город",
					1: "укажите регион",
					0: "адрес корректный!",
				}
				console.log(res)
				if (res.qc_complete === 0) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 5) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 10) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".form__data-comment")
						.text("")
				} else {
					field[0].setCustomValidity(qc_text[res.qc_complete])
					field
						.parent()
						.find(".form__data-comment")
						.text(qc_text[res.qc_complete])
				}
			},
			fail: function (e) {
				$("input[type=submit]").prop("disabled", false)
				console.log(e)
			},
		})
	}

	ending(count, one, two, many) {
		let end;

		if (count % 10 == 1 && count % 100 != 11)
			end = one;
		else if ((count % 10 > 1 && count % 10 < 5) && (count % 100 < 11 || count % 100 > 15))
			end = two;
		else
			end = many;

		return end;
	}

	calcTarifs(code, type) {
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=25&action=get_tarifs",
			type: "GET",
			data: {
				code: code,
				type: type
			},
			dataType: "json",
			success: function (res) {
				if (res.error) {
					alert(res.error);
				}
				else {
					if (res.pickup)
						$('.ordering-delivery__choose-label[for="delivery_type_1"] .ordering-delivery__choose-info').text(
							'от\xa0' + res.pickup.delivery_sum + '\xa0₽ | от\xa0' + res.pickup.calendar_min + '\xa0дн' + _this.ending(res.pickup.calendar_min, 'я', 'ей', 'ей'));
					if (res.courier)
						$('.ordering-delivery__choose-label[for="delivery_type_2"] .ordering-delivery__choose-info').text(
							'от\xa0' + res.courier.delivery_sum + '\xa0₽ | от\xa0' + res.courier.calendar_min + '\xa0дн' + _this.ending(res.courier.calendar_min, 'я', 'ей', 'ей'));

					if (type == 'kladr')
					{
						cookie.set('sdek_id', res.sdekId);
					}
				}
			},
			fail: function (e) {

				console.log(e)
			},
		})
	}

	calcDelivery(address) {
		let _this = this;
		this.address = address;
		$('.ordering-summary__loader').addClass('active');

		$.ajax({
			url: "/ajax.php?mid=25&action=calc_delivery",
			type: "GET",
			data: {
				address: address,
				promo: this.promo
			},
			dataType: "json",
			success: function (res) {
				if (res.error) {
					alert(res.error);
				}
				else {
					let price = parseInt(res.delivery_sum);
					$('.order-delivery-type').text('курьером');
					$('.order-delivery-adress').text(address);
					$('.order-delivery-price').text(price + ' ₽');
					$('.order-delivery-term').text(res.calendar_min + '-' + res.calendar_max + ' дня');

					$('#delivery_price').val(price);
					$('.order-total-sum').text((parseInt($('.order-total-sum').data('sum')) + price) + ' ₽');

					$('.ordering-summary__submit-btn').prop('disabled', false);

					_this.delivery_price = price;
					_this.delivery_term = res.calendar_min + '-' + res.calendar_max + ' дня';

					$('.ordering-summary__loader').removeClass('active');
				}
			},
			fail: function (e) {

				console.log(e)
			},
		})
	}



	calcPVZ(obj) {
		let _this = this;
		this.pvz = obj.city_code;
		$('#sdek_pvz').val(obj.code);
		$('.ordering-summary__loader').addClass('active');

		$.ajax({
			url: "/ajax.php?mid=25&action=calc_pvz",
			type: "GET",
			data: {
				code: obj.city_code,
				promo: this.promo
			},
			dataType: "json",
			success: function (res) {
				if (res.error) {
					alert(res.error);
				}
				else {
					let price = parseInt(res.delivery_sum);
					$('.order-delivery-type').text('в пункт выдачи');
					$('.order-delivery-adress').text(obj.city + ', ' + obj.address);
					$('.ordering-delivery__pvz-info span').text(obj.city + ', ' + obj.address);
					$('.order-delivery-price').text(price + ' ₽');
					$('.order-delivery-term').text(res.calendar_min + '-' + res.calendar_max + ' дня');

					$('#delivery_price').val(price);
					$('.order-total-sum').text((parseInt($('.order-total-sum').data('sum')) + price) + ' ₽');

					$('.ordering-summary__submit-btn').prop('disabled', false);

					$('.popup-cdek').removeClass("active");
					$("body").removeClass("no-scroll");

					_this.pvz_price = price;
					_this.pvz_term = res.calendar_min + '-' + res.calendar_max + ' дня';
					_this.pvz_name = obj.city + ', ' + obj.address;

					$('.ordering-summary__loader').removeClass('active');
				}
			},
			fail: function (e) {

				console.log(e)
			},
		})
	}

	applyEvents() {
		let _this = this;

		$('.cart-item__count-btn--plus').click(function () {
			let input = $(this).closest('.cart-item__count-container').find('.cart-item__count-input');
			input.val(input.val() * 1 + 1);
			input.trigger('change');
		});
		$('.cart-item__count-btn--minus').click(function () {
			let input = $(this).closest('.cart-item__count-container').find('.cart-item__count-input');
			if (input.val() > 1) {
				input.val(input.val() - 1);
				input.trigger('change');
			}
		});

		if ($("input[name=str_city]").length) {
			$("input[name=str_city]").suggestions({
				token: "93eaaba5a046a7a38d8811709d5ad45009930620",
				type: "ADDRESS",
				bounds: "city-settlement",
				onSuggestionsFetch: removeNonCity,
				onSelect: function (sug) {
					_this.calcTarifs(sug.data.kladr_id, 'kladr');
					cookie.set('str_city', sug.value.toString())
					cookie.set('city_kladr_id', sug.data.kladr_id.toString())
					console.log(sug);
				},

			})
			$("input[name=str_city]").blur(function () {

			})
		}



		//-----------------------------------------

		$('#delivery-select-item-pvz').html("<span>Пункт выдачи (от 99 руб.)</span>");

		$('#delivery-select-item-pvz').click(function () {

			$("#delivery-content-item-pvz").removeClass("visually-hidden");
			$("#delivery-content-item-courier").addClass("visually-hidden");
		});


		$('#delivery-select-item-courier').html("<span>Курьером (от 199 руб.)</span>");

		$('#delivery-select-item-courier').click(function () {

			$("#delivery-content-item-courier").removeClass("visually-hidden");
			$("#delivery-content-item-pvz").addClass("visually-hidden");
		});

		//-----------------------------------------

		$('.ordering-delivery__choose-input').change(function () {
			if ($(this).val() == 1) {
				$('.ordering-delivery__pvz').addClass('active');
				$('.ordering-delivery__courier').removeClass('active');
				$('.order-delivery-type').text('в пункт выдачи');

				if (_this.pvz)
				{
					$('.order-delivery-adress').text(_this.pvz_name);
					$('.order-delivery-price').text(_this.pvz_price + ' ₽');
					$('.order-delivery-term').text(_this.pvz_term);

					$('#delivery_price').val(_this.pvz_price);
					$('.order-total-sum').text(parseInt($('.order-total-sum').data('sum')) + _this.pvz_price + ' ₽');
				}
				else
				{
					$('.order-delivery-adress').text('выберите пункт на карте');
					$('.order-delivery-price').text('');
					$('.order-delivery-term').text('');

					$('#delivery_price').val('');
					$('.order-total-sum').text($('.order-total-sum').data('sum') + ' ₽');
				}
			}
			else if ($(this).val() == 2) {
				$('.ordering-delivery__courier').addClass('active');
				$('.ordering-delivery__pvz').removeClass('active');
				$('.order-delivery-type').text('курьером');

				if (_this.address)
				{
					$('.order-delivery-adress').text(_this.address);
					$('.order-delivery-price').text(_this.delivery_price + ' ₽');
					$('.order-delivery-term').text(_this.delivery_term);

					$('#delivery_price').val(_this.delivery_price);
					$('.order-total-sum').text(parseInt($('.order-total-sum').data('sum')) + _this.delivery_price + ' ₽');
				}
				else
				{
					$('.order-delivery-adress').text('укажите адрес');
					$('.order-delivery-price').text('');
					$('.order-delivery-term').text('');

					$('#delivery_price').val('');
					$('.order-total-sum').text($('.order-total-sum').data('sum') + ' ₽');
				}
			}
		});

		$(".ordering-delivery__pvz-open").on("click", function () {
			$("body").addClass("no-scroll");
			$(".popup-cdek").addClass("active");
			openSDEK();
		})


		if ($("input[name=delivery_address]").length) {
			$("input[name=delivery_address]").suggestions({
				token: "93eaaba5a046a7a38d8811709d5ad45009930620",
				type: "ADDRESS",
				onSelect: function (sug) {
					_this.calcDelivery(sug.value);
					console.log(sug);
				},
			})
			$("input[name=delivery_address]").blur(function () {

			})
		}
	}
}

//----------------------------------------

var deliveryType = 0;
var deliveryPVZ = 0;
var deliveryPrice = 0;
var deliveryTerm = 0;
var deliveryCityName = 0;
var deliveryCityCode = 0;

function openSDEK() {
	if (!order.ourWidjetPVZ)
	{
		order.ourWidjetPVZ = new CDEKWidget({
			root: 'for-pvz', // id элемента страницы, в который будет вписан виджет
			apiKey: "bcf4588a-d71d-4be4-91bd-c6a76b9350a1",
			servicepath: '/service.php', //ссылка на файл service.php на вашем сайте
			hideDeliveryOptions: {
				door: true,
			},
			defaultLocation: cookie.get('str_city') ? cookie.get('str_city') : 'г Санкт-Петербург',
			from: {
				country_code: 'RU',
				code: 137,
			},
			fixBounds: 'country',

			onChoose(type, tarif, address) {
				console.log(type);
				console.log(tarif);
				console.log(address);

				order.calcPVZ(address);
			},
		});
	}
}
